module.exports = __webpack_public_path__ + "img/findthispixelanomaly.jpg_w545.a2eb89b3.jpg";